import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export default function AuditLog() {
  const { data = [] } = useQuery({ queryKey: ["audit"], queryFn: async () => (await api.get("/audit")).data, refetchInterval: 10000 });
  return (
    <div className="animate-fade-in">
      <header className="h-14 border-b border-zinc-800 flex items-center px-6">
        <h1 className="font-heading text-lg font-semibold tracking-tight">Audit Log</h1>
      </header>
      <div className="p-6">
        <div className="border border-zinc-800 rounded-sm overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-zinc-950 text-[10px] uppercase tracking-wider text-zinc-500">
                <th className="text-left font-medium py-2 px-3">Timestamp</th>
                <th className="text-left font-medium py-2 px-3">Actor</th>
                <th className="text-left font-medium py-2 px-3">Action</th>
                <th className="text-left font-medium py-2 px-3">Target</th>
                <th className="text-left font-medium py-2 px-3">Details</th>
              </tr>
            </thead>
            <tbody>
              {data.map((a) => (
                <tr key={a.id} className="border-t border-zinc-800/60 hover:bg-zinc-900 transition-colors duration-150">
                  <td className="py-2 px-3 font-mono text-zinc-500 text-xs">{(a.timestamp || "").slice(0, 19).replace("T", " ")}</td>
                  <td className="py-2 px-3 text-xs text-zinc-300">{a.actor}</td>
                  <td className="py-2 px-3 font-mono text-blue-400 text-xs">{a.action}</td>
                  <td className="py-2 px-3 font-mono text-zinc-400 text-xs">{a.target || "—"}</td>
                  <td className="py-2 px-3 font-mono text-zinc-500 text-xs">{a.details && Object.keys(a.details).length ? JSON.stringify(a.details) : "—"}</td>
                </tr>
              ))}
              {data.length === 0 && <tr><td colSpan={5} className="py-10 text-center text-zinc-500 text-sm">No audit entries yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
